<template>
  <div class="app-container">
    <!-- <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="8" class="flex">
        <span style="flex-shrink: 0">
          角色名称
        </span>
        <el-input v-model="search.roleName" placeholder="请输入角色名称"></el-input>
      </el-col>
      <el-col :span="8" class="flex">
        <span> 所属组织 </span>
        <BelongOrgSelect ref="belongOrgRef" v-model="search.partnershipId"></BelongOrgSelect>
      </el-col>
      <el-col :span="8" class="flex">
        <el-button type="primary" size="medium" @click="searchDataFun">查询</el-button>
        <el-button size="medium" @click="resetForm">重置</el-button>
      </el-col>
    </el-row> -->
    <div class="m-b-10">
      <el-button type="primary" size="medium" @click="addOrgFun">+&nbsp;创建角色</el-button>
    </div>
    <el-table ref="checktableData" row-key="id" :data="tableDataList" v-loading="tableDataLoading" default-expand-all
      @selection-change="handleSelectionChange" :reserve-selection="true" height="60vh">
      <!-- <el-table-column type="selection" min-width="50" align="center">
      </el-table-column> -->
      <el-table-column label="角色编号" prop="id" width="120" align="center"></el-table-column>
      <el-table-column label="角色名称" prop="roleName" min-width="120" align="center"></el-table-column>
      <!-- <el-table-column label="所属组织" prop="partnershipId" min-width="100" align="center">
        <template slot-scope="scope">
          {{ belongOrgName(scope.row.partnershipId) }}
        </template>
      </el-table-column> -->
      <el-table-column label="角色描述" prop="description" min-width="160" align="center"></el-table-column>
      <el-table-column label="操作" fixed="right" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click=editRowFun(scope.row)>编辑</el-button>
          <el-button v-if="scope.row.parentId != 0" type="text" @click=deleteRowFun(scope.row)>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper" :current-page.sync="search.pageNum"
        :page-size.sync="search.pageSize" :page-sizes="[10, 20]" :total="tableDataTotalNum">
      </el-pagination>
    </div> -->
    <AddOrEditRole ref="addOrEditRoleRef" :orgTypeList="orgTypeList" @opera-success="searchDataFun"></AddOrEditRole>
  </div>
</template>
<script>
import AddOrEditRole from './components/AddOrEditRole'
import BelongOrgSelect from '@/components/BelongOrgSelect'
export default {
  name: 'roleAuth',
  components: {
    AddOrEditRole,
    BelongOrgSelect
  },
  data () {
    return {
      /**
       * tableDataLoading 表格数据加载是否完毕
       * tableDataList 表格数据
       * search 表单查询数据
       * tableDataTotalNum 表格数据总数
       * allSelectedIds 所有选中的数据
       * unSelectedIds 所有未选中的id
       */
      tableDataLoading: false,
      tableDataList: [],
      search: {
        roleName: '',
        partnershipId: '',
        pageSize: 999999999,
        pageNum: 1,
      },
      tableDataTotalNum: 0,
      allSelectedIds: [],
      unSelectedIds: [],
      orgTypeList: []
    }
  },
  created () {
    this.getOrgTypeList()
    this.getList()
  },
  methods: {
    searchDataFun () {
      this.search.pageNum = 1
      this.getList()
    },
    // 获取数据请求
    getList () {
      this.tableDataList = [];
      this.tableDataLoading = true;
      const { roleName = undefined, partnershipId = undefined, pageSize, pageNum } = this.search
      const url = `/autoapp-recovery-server-auth/api/tbl-role/pageRole?pageNum=${pageNum}&pageSize=${pageSize}&roleName=${roleName}&partnershipId=${partnershipId}`
      this.HttpService.get(url).then(res => {
        this.tableDataLoading = false
        if (res.statusCode === 200) {
          this.tableDataTotalNum = res.total || 0
          this.tableDataList = res.data || []
          if (this.tableDataList.length === 0) {
            this.$dialog({
              title: '温馨提示',
              content: '未查询到结果!',
              footBtn: false,
              width: '20%',
              dialogType: 'sighicon',
            })
          }
        } else {
          const tipMsg = res.message || '请求出错'
          this.$message.error(tipMsg)
        }
      })
    },
    // 表格选择改变
    handleSelectionChange (rows) {
      // console.log(rows)
    },
    // 页数改变
    handleSizeChange (val) {
      this.getList()
    },
    // 页码改变
    handleCurrentChange () {
      this.getList()
    },
    // 重置查询
    resetForm (formName) {
      this.search = {
        roleName: '',
        partnershipId: '',
        pageSize: 10,
        pageNum: 1,
      }
    },
    // 创建组织
    addOrgFun () {
      this.$refs.addOrEditRoleRef.openDialog('add')
    },
    // 编辑
    editRowFun (row) {
      this.$refs.addOrEditRoleRef.openDialog('edit', row)
    },
    // 删除
    deleteRowFun (row) {
      const id = row.id
      if (id) {
        this.$dialog({
          title: '温馨提示',
          content: '是否要删除，删除后不可以恢复！',
          cancel_buttton: '否',
          ok_buttton: '是',
          width: '400px',
          footBtn: 'card',
          dialogType: 'delete',
          onOk: () => {
            const url = '/autoapp-recovery-server-auth/api/tbl-role/removeRole'
            this.HttpService.delete(`${url}?id=${id}`, {}).then(res => {
              if (res.statusCode === 200) {
                this.$message.success('删除成功')
                this.getList()
              } else {
                const tipMsg = res.message || '操作失败'
                this.$message.error(tipMsg)
              }
            })
          },
          onCancel: () => {
            console.log('cancel');
          }
        })
      }
    },
    // 获取组织列表
    getOrgTypeList () {
      const url = '/autoapp-recovery-server-auth/api/tbl-partner-management/partnershipType'
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          const resData = res.data || []
          this.orgTypeList = resData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    belongOrgName (val) {
      const orgList = this.$refs.belongOrgRef.orgList
      const orgObj = orgList.find((item) => item.partnershipId == val) || ''
      return orgObj ? orgObj.partnerName : ''
    },
  }
}
</script>


<style scoped lang="scss">
.flex {
  display: flex;
  align-items: center;
  padding: 0 20px;

  span {
    min-width: 100px;
  }
}

.row-bg {
  margin-bottom: 15px;
}

.dialog {
  padding: 20px;

  .dialog-footer {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/roleAuth.vue